import styled from "styled-components";
import { Colors } from 'styles/app-styles';

interface PopoverProps {
  left: number|null,
  iconPos?: number,
  position?: string,
  show: boolean,
  top: number|null,
  width: number
}

export const Popover_s = styled.div<PopoverProps>`
  background: ${Colors.white};
  border: 2px solid ${Colors.towerGrey} !important;
  border-radius: 4px;
  height: auto;
  margin-top: 10px;
  position: absolute;
  ${props => (props.position === 'top right') ? `left: ${props.left}px;` : (props.position === 'top left') ? props.left && `left: ${props.left - 15}px;` : `margin-left: -${props.width / 2}px;`}
  visibility: ${p => p.show ? 'visible' : 'hidden'};
  width: ${p => p.width}px;
  z-index: 900;
  top: ${props => props.top}px;

  ::after {
    border: 10px solid transparent;
    border-bottom-color: ${Colors.towerGrey};
    content: "";
    height: 0;
    position: absolute;
    ${props => props.position && props.position === 'top right' ? `left: ${props.iconPos! - props.left! - 3}px;` : props.position === 'top left' ? `left: 14px;` : `margin-left: ${props.width / 2}px;` }
    top: -20px;
    width: 0;
  }
`

export const PopoverTitle_s = styled.div`
  background: ${Colors.inputFocus};
  color: ${Colors.darkDenim};
  display: flex;
  flex-direction: row;
  font-size: 16px;
  font-family: 'Roboto-Light',sans-serif;
  height: 30px;
  justify-content: space-between;
  line-height: 20px;
  padding: 5px 8px;

  svg {
    height: 16px;
    width: 16px;
  }
`

export const PopoverContent_s = styled.div`
  padding: 10px;
`

export const PopoverButtons_s = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
`
